<template>
  <div>
    <div
      v-for="block in sections"
      :key="block.index"
    >
      <div
        @click="selectSection(block)"
        :class="calculateClass(block)"
        :style="`padding-left: ${calculateClassPadding(block)}px;`"
      >
        <component
          class="toc-title"
          :is="`h${block.level}`"
        >
          {{ block.text }}
        </component>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'TableOfContent',
  data() {
    return {
      isActive: true,
    };
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  methods: {
    selectSection(block) {
      this.$emit('sectionSelected', block);
    },
    calculateClassPadding(block) {
      return 4 * ((block.level - 1) * 3 + 3);
    },
    calculateClass(block) {
      const classes = ['py-2 tableEntry'];
      if (block.focused) {
        classes.push('focusTableEntry');
      } else {
        classes.push('unfocusTableEntry');
      }
      return classes.join(' ');
    },
  },
  updated() {
    const elems = document.getElementsByClassName('focusTableEntry');
    if (elems.length > 0) {
      elems[0].scrollIntoView(false);
    }
  },
};
</script>
<style scoped>
.tableEntry {
  display: flex;
  flex-grow: 0;
  cursor: pointer;
  max-width: 400px;
}

.tableEntry * {
  font-size: 11px;
  font-weight: 500;
}
.focusTableEntry {
  color: white;
  background-color: #3C44C8;
  border-radius: 25px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.unfocusTableEntry {
  color: #232137;
}
.toc-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
